import { UserConstants } from '../constants';

let initialState = { driverError: '', driverCreating: false, driverCreated: false };
export function createDReducer(state = initialState, action) {
    switch (action.type) {
    case UserConstants.DRIVER_SUCCESS:
        return{
            driverCreated: true,
            driverCreating: false,
            driverError: '',
        };
    case UserConstants.DRIVER_REQUEST:
        return{
            driverCreating: true,
            driverCreated: false,
            driverError: '',
        };
    case UserConstants.DRIVER_ERROR:
        return {
            driverError: action.payload.message,    
            driverCreated: false,
            driverCreating: false,
        };
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/CreateDReducer.jsx